<template>
  <div :class="$style.container">
     <tabs
      :tabs="tabs"
      :currentTab="currentTab"
      :class="$style.tabs"
      @onClick="tab => currentTab = tab"
    />
    <SearchInput
      v-model="query"
      @clear="query = ''"
      :class="$style.search"
    />
    <div :class="$style.content">
      <PickerEmoji
        v-if="currentTab === 'emoji'"
        :query="query"
        @insert="emoji => $emit('insert:emoji', emoji)"
      />
      <!-- <PickerGiphy v-if="currentTab === 'gif'" />
      <PickerGiphy v-if="currentTab === 'stickers'" type="stickers" /> -->
      <template v-else>
        <PickerGiphy
          v-if="provider === 'giphy'"
          :type="currentTab"
          :query="query"
          @insert="gif => $emit('insert:gif', gif)"
        />
        <PickerTenor
          v-if="provider === 'tenor'"
          :type="currentTab"
          :query="query"
          @insert="gif => $emit('insert:gif', gif)"
        />
      </template>
    </div>
  </div>
</template>

<script>
import Tabs from 'vue-tabs-with-active-line'
import PickerEmoji from './PickerEmoji'
import PickerGiphy from './PickerGiphy'
import PickerTenor from './PickerTenor'
import SearchInput from '@/components/SearchInput'

export default {
  name: 'picker',
  props: {
    provider: {
      type: String,
      default: 'giphy'
    }
  },
  components: {
    Tabs,
    PickerEmoji,
    PickerGiphy,
    PickerTenor,
    SearchInput
  },
  data () {
    return {
      tabs: [
        {
          title: 'Emoji',
          value: 'emoji'
        },
        {
          title: 'Gifs',
          value: 'gifs'
        },
        {
          title: 'Stickers',
          value: 'stickers'
        }
      ],
      currentTab: 'emoji',
      query: ''
    }
  }
}
</script>

<style module lang="scss">
.container {
  width: 360px;
  height: 300px;
  padding: 0 4px 10px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.content {
  // overflow-y: scroll;
  flex-grow: 1;
  flex-shrink: 1;
  overflow: hidden;
}
.tabs {
  margin-bottom: 4px;
}
.search {
  margin-bottom: 4px;
}
</style>
